import { Link } from "react-router-dom";
import { CalendarCheck, ClipboardList, CreditCard, BarChart3, Users, Mail, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SiteLayout } from "@/components/site/Layout";
import { useSeo } from "@/context/ContentContext";

const IMG = "https://images.unsplash.com/photo-1758448511255-ac2a24a135d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
const ITEMS = [
  { icon: CalendarCheck, t: "Online booking page", d: "Your own page on the marketplace, with live open times." },
  { icon: Users, t: "Practitioners & hours", d: "Set each practitioner's weekly availability and treatments." },
  { icon: ClipboardList, t: "Intake forms", d: "Patients answer health questions before they arrive." },
  { icon: CreditCard, t: "Paid upfront", d: "Card payments at booking mean fewer no-shows." },
  { icon: Mail, t: "Email confirmations", d: "Patients and your clinic get a confirmation email for every booking." },
  { icon: BarChart3, t: "Reports", d: "Revenue and bookings by day, treatment and practitioner." },
];

export default function ForClinics() {
  useSeo("for_clinics");
  return (
    <SiteLayout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-2 gap-12 items-center">
        <div className="space-y-6 fade-up">
          <p className="eyebrow">For clinics</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.02]">Fill your diary, cut the admin</h1>
          <p className="text-base sm:text-lg text-slate-600">ClinicsPro brings booking, intake, payments and reporting into one place for independent health and wellness clinics.</p>
          <Button size="lg" className="rounded-full h-12 px-7" asChild data-testid="for-clinics-signup-button">
            <Link to="/for-clinics/signup">List your clinic <ArrowRight className="h-4 w-4 ml-2" /></Link>
          </Button>
          <Button size="lg" variant="outline" className="rounded-full h-12 px-7 ml-3 bg-card" asChild data-testid="for-clinics-pricing-button">
            <Link to="/pricing">See pricing</Link>
          </Button>
        </div>
        <img src={IMG} alt="Modern clinic interior" className="rounded-[2rem] h-[420px] w-full object-cover shadow-xl" />
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {ITEMS.map(({ icon: I, t, d }) => (
          <div key={t} className="rounded-2xl bg-card border border-border p-6 lift">
            <span className="h-10 w-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center mb-4"><I className="h-5 w-5" /></span>
            <p className="font-display font-bold">{t}</p>
            <p className="text-sm text-muted-foreground mt-1">{d}</p>
          </div>
        ))}
      </section>
    </SiteLayout>
  );
}
